import { createStyles, makeStyles } from "@mui/styles";
import { type Theme } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			"& .MuiSelect-root": {
				backgroundColor: "#FFF",
			},
		},
		formControl: {
			width: "99%",
			marginTop: 8,
		},
		chips: {
			display: "flex",
			flexWrap: "wrap",
		},
		chip: {
			margin: 2,
		},
		noLabel: {
			marginTop: theme.spacing(3),
		},
	}),
);

type Props = {
	value: string;
	onChange: Function;
	disabled?: boolean;
};

const optionTexts: { [key: string]: string } = {
	O: "OK",
	W: "Warning",
	A: "Alert",
};

export const OptionTypePicker = ({ value, onChange, disabled }: Props) => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<FormControl
				variant="outlined"
				margin="dense"
				className={classes.formControl}
			>
				<InputLabel id="option-select-label">Option</InputLabel>
				<Select
					labelId="option-select-label"
					id="option-select"
					disabled={!!disabled}
					autoWidth={true}
					value={value}
					onChange={onChange as any}
					label="Option"
					style={{ marginBottom: 10 }}
				>
					{Object.entries(optionTexts).map(([code, text]) => (
						<MenuItem key={`option-${code}`} value={code}>
							<div style={{ marginLeft: 10 }}>{text}</div>
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
};
